import { render } from "./InvoiceModal.vue?vue&type=template&id=6cd31dfb&scoped=true"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"

import "./InvoiceModal.vue?vue&type=style&index=0&id=6cd31dfb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6cd31dfb"

export default script